<section class="properties-dashboard">
    <div>

        <sp-steps-for-planning
            [plans]="plans$ | async"
            [property]="selectedProperty$ | async"
            [selectedFiscalYear]="selectedFiscalYear$ | async"
            [disclosurePlanId]="disclosurePlanId$ | async"
        ></sp-steps-for-planning>

        <div class="margin-top-20">
            <sp-dashboard-future-display *ngIf="financialHealthReport$ | async"
                [fiscalYear]="selectedFiscalYear$ | async"
                [reportData]="financialHealthReport$ | async"
                [disclosurePlanId]="disclosurePlanId$ | async"
                [plans]="plans$ | async"
                (backToDashboard)="onBackToDashboard()">
            </sp-dashboard-future-display>
        </div>

    </div>
</section>
